import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';

import { IdentityService } from '~core/modules/identity/services/identity.service';
import { Token } from '~core/modules/identity/models/identity.model';
import {ImpersonationService} from '../../services/impersonation.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';

@Component({
  selector: 'app-impersonate',
  template: '',
})
export class ImpersonateComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly impersonationService: ImpersonationService,
    private readonly identityService: IdentityService,
    private readonly homepageNavigatorService: HomepageNavigatorService
  ) {}

  public ngOnInit(): void {
    const params = this.route.snapshot.queryParams;

    if (params._switch_user && params._switch_user_token) {
      this.identityService.unauthorize();

      this.impersonationService.exchangeCodeToAccessToken(params).pipe(
        takeUntil(this.destroy$)
      ).subscribe(result => {
        const token: Token = {
          token_type: 'Bearer',
          access_token: result['access_token'],
        };
        this.identityService.authorize(token).pipe(
          takeUntil(this.destroy$)
        ).subscribe(() => {
          this.homepageNavigatorService.navigateToHomepage().subscribe();
        });
      });
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
